import {FuelData} from "../types/FuelData";
import {StagingTitelineAppFuel} from "../types/StagingTitelineAppFuel";
import { getApiUrl } from '../config/api';

export const fetchFuelByPid = async (pid?: number, aid: number = -1): Promise<FuelData[]> => {
    const validPid = pid ?? -1;
    const apiUrl = getApiUrl(`/api/TitelineFuel/GetFuelByPid/${validPid}`);

    try {
        const response = await fetch(apiUrl, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            if (response.status === 404) {
                console.warn(`No flue found for Pid: ${validPid} (404 Not Found)`);
            } else {
                console.error(`Error fetching flue for Pid: ${validPid} - ${response.status} ${response.statusText}`);
            }
            return [];
        }

        let backendData: StagingTitelineAppFuel[] = await response.json();
        if (pid === -1) {
            backendData = backendData.filter((fuel) => fuel.DataSource === aid.toString());
        }

        return backendData.map((fuel) => ({
            key: fuel.Fid,
            fid: fuel.Fid,
            pid: fuel.Pid,
            loads: fuel.Loads,
            kilometres: fuel.Kilometres,
            litres: fuel.Litres,
            hours: fuel.Hours,
            driver: fuel.Driver,
        }));

    } catch (error) {
        console.error("Error in fetchFuelByPid API call:", error);
        return [];
    }
};

export const addFuelRow = async (fuelRow: FuelData, aid: number = -1) => {
    const apiUrl = getApiUrl('/api/TitelineFuel/AddFuel');

    const cloudPayload = [
        {
            Pid: fuelRow.pid,
            Loads: fuelRow.loads,
            Kilometres: fuelRow.kilometres,
            Litres: fuelRow.litres,
            Hours: fuelRow.hours,
            Driver: fuelRow.driver,
            DataSource: aid,
        },
    ];

    try {
        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(cloudPayload),
        });

        if (response.ok) {
            console.log("Fuel row added to cloud successfully.");
            return true;
        } else {
            console.error(
                "Failed to add fuel row to cloud:",
                response.status,
                response.statusText
            );
            return false;
        }
    } catch (error) {
        console.error("Error in addFuelRow API call:", error);
        return false;
    }
};

export const updateFuelRow = async (fid: number, updatedRow: FuelData) => {
    const apiUrl = getApiUrl(`/api/TitelineFuel/UpdateFuelByFid/${fid}`);

    const cloudPayload = {
        Loads: updatedRow.loads,
        Kilometres: updatedRow.kilometres,
        Litres: updatedRow.litres,
        Hours: updatedRow.hours,
        Driver: updatedRow.driver,
    };

    console.log(`cloudPayload`, cloudPayload);

    try {
        const response = await fetch(apiUrl, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(cloudPayload),
        });

        if (response.ok) {
            console.log(`Fuel row with Fid ${fid} updated successfully.`);
            return true;
        } else {
            console.error(
                `Failed to update fuel row with Fid ${fid}:`,
                response.status,
                response.statusText
            );
            return false;
        }
    } catch (error) {
        console.error("Error in updateFuelRow API call:", error);
        return false;
    }
};

export const deleteFuelByFid = async (fid: number) => {
    const apiUrl = getApiUrl(`/api/TitelineFuel/DeleteFuelByFid/${fid}`);

    try {
        const response = await fetch(apiUrl, {
            method: "DELETE",
        });

        if (response.ok) {
            const responseData = await response.json();
            console.log("DeleteFuelByFid API response:", responseData);
            return true;
        } else {
            console.error("Failed to delete fuel row from the cloud:", response.status, response.statusText);
            return false;
        }
    } catch (error) {
        console.error("Error in deleteFuelByFid API call:", error);
        return false;
    }
};